'use strict';
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.$$observable = exports.observable = undefined;
exports.getSymbolObservable = getSymbolObservable;

var _root = require('../util/root');

function getSymbolObservable(context) {
    var $$observable = void 0;
    var _Symbol = context.Symbol;
    if (typeof _Symbol === 'function') {
        if (_Symbol.observable) {
            $$observable = _Symbol.observable;
        } else {
            $$observable = _Symbol('observable');
            _Symbol.observable = $$observable;
        }
    } else {
        $$observable = '@@observable';
    }
    return $$observable;
}
var observable = exports.observable = getSymbolObservable(_root.root);
/**
 * @deprecated use observable instead
 */
var $$observable = exports.$$observable = observable;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/symbol/observable.js
// module id = 96
// module chunks = 177